(function() {
  'use strict';

  angular
    .module('eclipseApp.checkout')

    .controller('cartCtrl', [
      '$scope',
      'cartManager',
      '$rootScope',
      '$state',
      'utePopoverFactory',
      'buyService',
      '$location',
      'uteModal',
      'notifier',
      'commonService',
      'uteLocale',
      'buyUtils',
      'dtmService',
      'dtmServiceConstants',
      '$timeout',
      '$http',
      'uteEndpoint',
      function(
        $scope,
        cartManager,
        $rootScope,
        $state,
        utePopoverFactory,
        buyService,
        $location,
        uteModal,
        notifier,
        commonService,
        uteLocale,
        buyUtils,
        dtmService,
        dtmServiceConstants,
        $timeout,
        $http,
        uteEndpoint
      ) {
        $rootScope.$watch('shoppingCart', function(newShoppingCart) {
          $scope.cartItems = newShoppingCart;
          $rootScope.language = buyUtils.getAppLang();
          var tierInCart = cartManager.internet.tierInCart();
          $scope.promoOfferId = $rootScope.promoOfferId ? $rootScope.promoOfferId : null;
          $scope.discountOffers = $rootScope.discountOffers ? $rootScope.discountOffers : null;
          if (tierInCart && $scope.promoOfferId === null) {
            if (
              commonService.customerHasInternetService &&
              commonService.internetAccountStatus !== 'SUSPENDED' &&
              commonService.internetAccountStatus !== 'CANCELLED'
            ) {
              $scope.promoOfferId = null;
            } else {
              $timeout(function() {
                /* DSO-15392 start */
                var isOfferIdEligible = buyService.isPromoOfferIdEligible(tierInCart.selectedOffer.offerId);
                if (isOfferIdEligible === null) {
                  buyService.getInternetPromos().then(function(data) {
                    if (data) {
                      isOfferIdEligible = buyService.isPromoOfferIdEligible(tierInCart.selectedOffer.offerId);
                      $scope.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
                      $scope.discountOffers = buyService.getDiscountOffers();
                    }
                  });
                } else {
                  $scope.promoOfferId = buyService.getPromoOfferId(isOfferIdEligible);
                  $scope.discountOffers = buyService.getDiscountOffers();
                }
                $rootScope.promoOfferId = $scope.promoOfferId;
                $rootScope.discountOffers = $scope.discountOffers;
                /* DSO-15392 end */
              }, 0);
            }
          } else if (tierInCart && $rootScope.discountOffers === null && !$rootScope.ruiMethods.user.is.loggedIn()) {
            buyService.getInternetPromos().then(function(data) {
              $scope.discountOffers = data;
            });
          } else if (!tierInCart) {
            $scope.promoOfferId = null;
            $rootScope.promoOfferId = null;
            $scope.discountOffers = null;
            $rootScope.discountOffers = null;
          }
        });

        //DTM changes -FUSS-1521 internet cart summary
        var tierInCart = cartManager.internet.tierInCart();
        //$scope.promoOfferId = $rootScope.promoOfferId ? $rootScope.promoOfferId : null;
        if (tierInCart) {
          if (tierInCart.selectedOffer && tierInCart.selectedOffer.offerPrice) {
            dtmService.setVar(
              dtmServiceConstants.dtmRules.buyInternet.selectedProduct,
              tierInCart.selectedOffer.offerId
            );
            dtmService.setVar(
              dtmServiceConstants.dtmRules.buyInternet.productPrice,
              tierInCart.selectedOffer.offerPrice.price
            );
          }
          dtmService.direct(dtmServiceConstants.dtmRules.buyInternet.addToCart.ruleName);
        }
        $scope.lang = buyUtils.getAppLang();
        // total price frequency
        $scope.totalPriceFrequency = 'monthly';

        // wireless cart quantity
        $scope.wirelessCartQuantity = cartManager.wireless.get.cartQuantity();

        // remove from cart functionality
        $scope.removeOfferFromCart = function(tierId, productId, offerId) {
          cartManager.internet.removeOffer(tierId, productId, offerId).then(function() {});
        };

        // remove iptv from cart functionality
        $scope.removeIptvOfferFromCart = function(offerId) {
          cartManager.iptv.removeOffer(offerId).then(function() {});
        };

        $scope.isCartSummary = function() {
          return $state.current.name === 'cartSummary';
        };

        /**
         * called by cart-summary.html
         * fire analytics click event
         * goes back to the internet state
         */
        $scope.editCart = function() {
          $state.go('internet');
        };

        $scope.editIptv = function() {
          $state.go('tvBuildYourSolution');
        };

        $scope.processCheckout = function(route) {
          // var _activeUserType;
          if ($rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent()) {
            console.log('customerHasInternetService', commonService.customerHasInternetService);

            /*
             * @if
             * handle case if logged-in
             * handle case if agent
             */

            // NOTE uncomment when every one is ready

            // if ($rootScope.userInfo && $rootScope.userInfo.profileType && commonService.customerHasWirelessService && !commonService.customerHasInternetService) {
            //   console.log('customer profileType ', $rootScope);

            if (buyService.hasSession()) {
              /*
               * @if user is already logged-in and has checkout session in progress
               * do validateCart
               * do reset steps after fulfillment
               *
               */

              notifier.notify.processing();

              cartManager.validate().then(
                function(res) {
                  console.log('@cart:checkout():validateCart():SUCCESS ', res);

                  if (res && res.data && res.data.validateCart) {
                    if (res.data.validateCart.error) {
                      _satellite.setVar('error', 'FHSI | fulfillment:searchAddress:reject');
                      _satellite.track('bfa-fhsi-error');
                      console.log('@cart:validateCart() IF1: SHOULD CALL NOTIFIER.NOTIFY.ERROR');
                      notifier.notify.error({ errorCode: res.data.validateCart.error });
                      return;
                    }

                    // once validate cart returned
                    // steps from fulfillment onward will be reset
                    // user should land on fulfillment options

                    // reset steps
                    // buyService.resetStep('paymentOptions');
                    buyService.resetStep('fulfillment');

                    // call nextOperation
                    // proceed to next step which ever was reset once last operation is called
                    if (res.data.validateCart.nextOperation) {
                      buyService.doOperation(res.data.validateCart.nextOperation);
                    }
                  } else {
                    _satellite.setVar('error', 'FHSI | Invalid response card-summary');
                    _satellite.track('bfa-fhsi-error');
                    notifier.notify.error({ errorCode: 'INVALIDRESPONSEFORMAT' });
                  }
                },
                function(res, status) {
                  console.log('@cart:processRequest():validateCart():reject.resp ', res, status);
                  buyService.parseHTTPErrorResponse(res, status);
                }
              );

              return;
            }

            /*
             * handle fresh checkout
             */
            $state.go(route);

            //   /*
            //    * @if
            //    * handle if user has wireless and DOESN'T have internet-service
            //    */

            //   // interate to all profile types
            //   for (_activeUserType in $rootScope.userInfo.profileType) {

            //     // get profileType `key which has value of `true
            //     if ($rootScope.userInfo.profileType[_activeUserType]) {

            //       switch (_activeUserType) {
            //         case 'groupId':
            //         case 'owner':
            //           // if already logged in and no previous checkout session
            //           // proceed to create profile
            //           $state.go(route);
            //           break;
            //         case 'prepaid':
            //         case 'subscriber':
            //           // uteModal.open({
            //           //   templateUrl: 'modules/checkout/views/credential-exist-modal.html',
            //           //   controller: 'CredentialExistModalCtrl'
            //           // });

            //           // show call care modal
            //           notifier.notify.info({
            //             title: 'global.label.oops',
            //             desc: 'global.message.unauthorizedUser',
            //             templateUrl: 'modules/checkout/views/fragments/modal/contact-footer.html'});
            //           return;
            //           break;
            //         default:
            //       }

            //       break;
            //     // /if
            //     }
            //   // /for in
            //   }
            // // /profileType && customerHasWirelessService && !customerHasInternetService
            // }
          } else {
            /*
             * @else
             * handle anon flow
             */

            if (buyService.hasSession()) {
              /*
               * @if user is already logged-in and has checkout session in progress
               * do validateCart
               * do reset steps after fulfillment
               *
               */

              notifier.notify.processing();

              cartManager.validate().then(
                function(res) {
                  console.log('@cart:checkout():validateCart():SUCCESS ', res);

                  if (res.data.validateCart.error) {
                    console.log('@cart:validateCart() IF1: SHOULD CALL NOTIFIER.NOTIFY.ERROR');
                    _satellite.setVar('error', 'FHSI | validateCart() IF1: SHOULD CALL NOTIFIER.NOTIFY.ERROR');
                    _satellite.track('bfa-fhsi-error');
                    notifier.notify.error({ errorCode: res.data.validateCart.error });
                    return;
                  }

                  // once validate cart returned
                  // steps from fulfillment onward will be reset
                  // user should land on fulfillment options

                  // reset steps
                  // buyService.resetStep('paymentOptions');
                  buyService.resetStep('fulfillment');

                  // call nextOperation
                  // proceed to next step which ever was reset once last operation is called
                  buyService.doOperation(res.data.validateCart.nextOperation);
                },
                function(res, status) {
                  console.log('@cart:processRequest():validateCart():reject.resp ', res, status);
                  buyService.parseHTTPErrorResponse(res, status);
                }
              );

              return;
            } else {
              /**
               * We are hitting heartbeat api to update the session.
               */

              var params = {
                userId: $rootScope.atg && $rootScope.atg.userId ? $rootScope.atg.userId.value : 'default',
                hashKey: $rootScope.atg && $rootScope.atg.hashKey ? $rootScope.atg.hashKey.value : 'default'
              };
              $http({
                method: 'POST',
                url: uteEndpoint('checkHeartBeat'),
                data: params
              }).error(function(res, status) {
                $modalInstance.close();
                switch (status) {
                  case 500:
                  case 5000:
                  case 50000:
                    notifier.notify.error({
                      errorCode: status
                    });
                    break;
                  default:
                    notifier.notify.error();
                }
              });
            }

            /*
             * handle fresh checkout
             */
            $state.go(route);

            /*
             * @else
             * if user is not loggedin
             * prompt an option to proceed as new customer or create a new account
             */

            // uteModal.open({
            //   templateUrl: 'modules/checkout/views/decision-modal.html',
            //   controller: 'decisionModalCtrl',
            //   size: 'lg',
            //   resolve: {
            //     data: function () {
            //       return {
            //         formData: {},
            //         displayMessage: '',
            //         parent: null,
            //         processRoute: null,
            //         showNewCustomerButton: false,
            //         focusEmail: function () {}
            //       };
            //     }
            //   }
            // });
            // return;
          }

          /**
             if (!buyService.hasSession()) {
             // not editting -> normal flow

             // if user is not logged in
             // show an option to log-in
             if (!$rootScope.ruiMethods.user.is.loggedIn()) {
             //EC-44 story resolution.
             uteModal.open({
             templateUrl: 'modules/checkout/views/decision-modal.html',
             controller: 'decisionModalCtrl',
             size: 'lg',
             resolve: {
             formData: null,
             displayMessage: null,
             processRoute: route,
             parent: $scope,
             showNewCustomerButton: true
             }
             });
             return;
             }

             // if already logged in and no previous checkout session
             // proceed to create profile
             $state.go(route);
             } else {
             // when editting
             // validateCart
             // doNextOperation

             notifier.notify.processing();

             // @else block
             // if a checkout session is in progress and returning to checkout flow
             // should call validate-cart
             cartManager.validate().then(function (res) {
             console.log('@cart:checkout():validateCart():SUCCESS ', res);

             if (res.data.validateCart.error) {
             notifier.notify.error({ errorCode: res.data.validateCart.error });
             return;
             }

             // once validate cart returned
             // steps from fulfillment onward will be reset
             // user should land on fulfillment options

             // reset steps
             // buyService.resetStep('paymentOptions');
             buyService.resetStep('fulfillment');


             // call nextOperation
             // proceed to next step which ever was reset once last operation is called
             buyService.doOperation(res.data.validateCart.nextOperation);

             }, function (res, status) {
             console.log('@cart:processRequest():validateCart():reject.resp ', res, status);
             buyService.parseHTTPErrorResponse(res, status);
             });

             }
          */
        };

        // redirect to checkout
        $scope.checkout = function() {
          var _route = 'buy';
          buyService.setCheckoutMode(false);

          // close popover before leaving
          utePopoverFactory.hideAllOpenPopovers();

          $scope.processCheckout(_route);
        };
      }
    ]);
})();
